import React from "react"
import { Helmet } from "react-helmet"
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss')

const wineDinner = () => {
  return (
    <div className={classes.WineDinner}>
      <Helmet>
        <title>Waterfront Wine Pairings at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>September Wine Dinner</h1>
                <h2 className={classes.bold}>
                  September 3rd <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;&middot;&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;&middot;&nbsp;</span> $60 Per Guest
                </h2>
                <h3>Hosted by Fullerton Vineyards</h3>
                <h4>For Reservations: <br className={classes.br400} /> <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>


          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>                
                <h5>First Course</h5>
                <h4>Tuna Poke</h4>
                <p>Lightly Seared Sesame Seed Tuna · Served with Pickled Ginger, Onions, Fresh Cilantro, Wasabi Aioli, and Pita Chips</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Les Fleurs Blanches · Brut · NV</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>Chicken Piccata</h4>
                <p>Chicken Roulade, Sun Dried Tomatoes, Ricotta Cheese · Served with Fresh Herb Orzo, Roasted Pepper Coulis</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Three Otters · Pinot Gris · 2025 Oregon</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>White Seared Scallops</h4>
                <p>Seared Scallops with Strawberry Risotto, Swiss Chard, Brown Butter</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Three Otters · Rosé · 2025 Oregon</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>Chocolate Cannoli</h4>
                <p>Chocolate Cannoli, Drunken Dark Cherries</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Three Otters · Red Pinot Noir · 2024 Oregon</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default wineDinner